import { ReactNode, CSSProperties } from 'react';
import { Drawer as VaulDrawer } from 'vaul';

type DrawerProps = {
  /** Whether the drawer is open */
  open?: boolean;
  /** Callback when the drawer should close */
  onClose: () => void;
  /** Anchor position: 'left' or 'right' */
  anchor?: 'left' | 'right';
  /** Content to render inside the drawer */
  children: ReactNode;
  /** Custom classes for root element */
  classes?: {
    root?: string;
    paper?: string;
  };
  /** Custom style for the drawer content */
  style?: CSSProperties;
  /** Data test id */
  'data-testid'?: string;
};

const Drawer = ({ open, onClose, anchor = 'left', children, classes, style, 'data-testid': testId }: DrawerProps) => {
  const handleOpenChange = (isOpen: boolean) => {
    if (!isOpen) {
      onClose();
    }
  };

  const isLeft = anchor === 'left';

  return (
    <VaulDrawer.Root open={open} direction={anchor} onOpenChange={handleOpenChange} modal={true} shouldScaleBackground={false}>
      <VaulDrawer.Portal>
        <VaulDrawer.Overlay
          className={classes?.root}
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.4)',
          }}
        />
        <VaulDrawer.Content
          data-testid={testId}
          className={classes?.paper}
          style={{
            position: 'fixed',
            top: 0,
            bottom: 0,
            [isLeft ? 'left' : 'right']: 0,
            width: 'auto',
            height: '100vh',
            maxHeight: '100vh',
            outline: 'none',
            overflow: 'auto',
            ...style,
          }}
        >
          <VaulDrawer.Title style={{ position: 'absolute', width: 1, height: 1, overflow: 'hidden' }}>drawer</VaulDrawer.Title>
          {children}
        </VaulDrawer.Content>
      </VaulDrawer.Portal>
    </VaulDrawer.Root>
  );
};

export default Drawer;
